module.exports = __webpack_public_path__ + "static/media/bearings1.d0cf492d.jpg";